import React from "react";
import {
  Headline,
  SectionContent,
  ButtonPrimary,
  ButtonSecondary,
  ButtonSecondaryInverse,
  ButtonPrimaryTransparent,
} from "../../../../components";
import { applyKey } from "../../../../utils";

const SampleButtons = () => {
  return (
    <SectionContent>
      <Headline nivel="2" styleAs="3" text="Botões" />
      {[
        { variant: ButtonPrimary },
        { variant: ButtonSecondary },
        { variant: ButtonSecondaryInverse },
        { variant: ButtonPrimaryTransparent },
      ].map(({ variant: Button }) =>
        applyKey(["sm", "md"], (size) => (
          <>
            <Button label={`Botão ${Button.name} ${size}`} bSize={size} />{" "}
            <Button
              href="#"
              label={`Botão com link ${Button.name} ${size}`}
              bSize={size}
            />{" "}
            <Button
              label={`Botão ${Button.name} ${size} em loading`}
              bSize={size}
              loading
            />{" "}
            <Button
              label={`Botão ${Button.name} ${size} desabilitado`}
              bSize={size}
              disabled
            />
            <br />
          </>
        ))
      )}
    </SectionContent>
  );
};

SampleButtons.propTypes = {};

export default SampleButtons;
